/**
 * @generated SignedSource<<fff20dd826b9bbeb6289fab99fde6209>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedPrintDetailsLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedPrintDetails_user">;
  readonly " $fragmentType": "PdpRespSharedPrintDetailsLazy_user";
};
export type PdpRespSharedPrintDetailsLazy_user$key = {
  readonly " $data"?: PdpRespSharedPrintDetailsLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedPrintDetailsLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedPrintDetailsLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetails_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9c3c223891b4ba12009a43b430ff899c";

export default node;
